// Mirrors alooma's referringDomain split (`_.info.referringDomain`) so a pinned
// $referring_domain equals what alooma computes live.
export const referringDomain = (referrer: string): string => {
  const split = referrer.split('/');
  return split.length >= 3 ? split[2] : '';
};

// Side-effect free and guarded so it is safe to import server-side, unlike alooma.js,
// which reads navigator at import time and is client-only.
const pageUrlContext = (): {
  $current_url: string;
  $referrer: string;
  $referring_domain: string;
} => {
  const referrer = typeof document === 'undefined' ? '' : document.referrer;
  return {
    $current_url: typeof window === 'undefined' ? '' : window.location?.href ?? '',
    $referrer: referrer,
    $referring_domain: referringDomain(referrer),
  };
};

export default pageUrlContext;
